/** Shared F2 / U2 / F5 persistMode fail-closed for Control Bridge write clients. */

export type ControlBridgePersistMode = 'patch' | 'workspace_disk' | 'unknown';
export type ControlBridgeSotPlane = 'disk' | 'hosted';

export function normalizeControlBridgePersistMode(
  raw: unknown
): ControlBridgePersistMode | undefined {
  if (raw === 'patch' || raw === 'workspace_disk' || raw === 'unknown') return raw;
  if (raw === 'db' || raw === 'postgres') return 'patch';
  if (raw === 'disk' || raw === 'workspace') return 'workspace_disk';
  return undefined;
}

export function normalizeControlBridgeSotPlane(
  raw: unknown
): ControlBridgeSotPlane | undefined {
  if (raw === 'disk' || raw === 'hosted') return raw;
  return undefined;
}

export function formatPersistModeNotPatchMessage(
  surface: string,
  persistMode: ControlBridgePersistMode | undefined,
  sotPlane?: ControlBridgeSotPlane
): string {
  const mode = persistMode ?? 'unknown';
  if (sotPlane === 'disk') {
    return (
      `${surface} refused hosted persist (persistMode=${mode}, sotPlane=disk). ` +
      `This model is disk-SoT until cutover; Control Bridge product writes to Postgres ` +
      `are the non-SoT plane and are fail-closed. After F5/F6 cutover (hosted marker), ` +
      `writes require persistMode=patch.`
    );
  }
  return (
    `${surface} did not persist to Postgres (persistMode=${mode}). ` +
    `ExoPanel and related Control Bridge writes require persistMode=patch on every slug; ` +
    `workspace_disk is rejected. If the server already applied a disk write, refresh before retrying ` +
    `(retry reuses the same operation id when one was issued).`
  );
}
